const skeletonComponent = `
  <div>
    <div class="products" data-column-grid="skeleton">
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
      <div class="product prod-card is-loading">
        <figure class="prod-card__media-container"></figure>
        <header class="prod-card__header">
          <div class="prod-card__details">
            <span class="prod-card__title"></span>
            <span class="prod-card__prices"></span>
          </div>
        </header>
      </div>
    </div>
  </div>`;
export default skeletonComponent;
